import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';

@Injectable()
export class RoleHelper {
  constructor(private userService: UserService) {
  }

  isAdmin(): boolean {
    return this.role === 'Administrator';
  }

  isPlanerProizvodnje(): boolean {
    return this.role === 'Planer proizvodnje';
  }

  isSefSektoraRazvoja(): boolean {
    return this.role === 'Šef sektora razvoja';
  }

  isOdgovorniProjektant(): boolean {
    return this.role === 'Odgovorni projektant';
  }

  isTehnolog(): boolean {
    return this.role === 'Tehnolog';
  }

  isSefSektora(): boolean {
    return this.role === 'Šef sektora';
  }

  isMagacioner(): boolean {
    return this.role === 'Magacioner';
  }

  get role(): string {
    return this.userService.getRole();
  }

  get roles(): any {
    return this.userService.getRoleList();
  }

  isVisibleOption(option) {
    const options = {
      addOrder: ['Administrator', 'Planer proizvodnje'],
      approveDocumentation: ['Administrator', 'Planer proizvodnje', 'Rukovodilac razvoja'],
      approveMaterials: ['Administrator', 'Planer proizvodnje', 'Rukovodilac razvoja'],
      approveOperation: ['Administrator', 'Planer proizvodnje', 'Tehnolog'],
    };

    return options[option].includes(this.role);
  }
}
